/**Created by steven on 2018/4/25.*/

<template>
  <transition name="st-indicator">
    <div class="ui-loading"  v-show="visible" @touchmove.stop.prevent>
      <i>
         <div class='sk-circle sk-circle-1'></div>
         <div class='sk-circle sk-circle-2'></div>
         <div class='sk-circle sk-circle-3'></div>
         <div class='sk-circle sk-circle-4'></div>
         <div class='sk-circle sk-circle-5'></div>
         <div class='sk-circle sk-circle-6'></div>
         <div class='sk-circle sk-circle-7'></div>
         <div class='sk-circle sk-circle-8'></div>
         <div class='sk-circle sk-circle-9'></div>
         <div class='sk-circle sk-circle-10'></div>
         <div class='sk-circle sk-circle-11'></div>
         <div class='sk-circle sk-circle-12'></div>
         <!--div class='sk-circle sk-circle-1'>  子</div>
         <div class='sk-circle sk-circle-2'>  丑</div>
         <div class='sk-circle sk-circle-3'>  寅</div>
         <div class='sk-circle sk-circle-4'>  卯</div>
         <div class='sk-circle sk-circle-5'>  辰</div>
         <div class='sk-circle sk-circle-6'>  巳</div>
         <div class='sk-circle sk-circle-7'>  午</div>
         <div class='sk-circle sk-circle-8'>  未</div>
         <div class='sk-circle sk-circle-9'>  申</div>
         <div class='sk-circle sk-circle-10'>酉</div>
         <div class='sk-circle sk-circle-11'>戌</div>
         <div class='sk-circle sk-circle-12'>亥</div-->
      </i>
      <div class="ui-loading-mask">
      </div>
    </div>
  </transition>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .st-indicator-enter,
  .st-indicator-leave-active {
    opacity: 0;
  }
  .ui-loading{
    transition: opacity .2s linear;
    position:absolute;
    left:0;
    right 0
    top:0;
    bottom 0

    z-index: 9999;
    .ui-loading-mask {
      position:absolute;
      top:0;
      left:0;
      background-color: #000;
      opacity: .2;
      z-index: 1
    }
    i{
      height: 50px;width:50px;
      display: block;
      background: url(loading.png) no-repeat center center;
      background-size:60% 60%;
      position: absolute;
      z-index: 2
      left:50%
      top 50%
      transform translate(-50%,-50%)
    }
  }
.loading_text{position:absolute;top:80px;font-style:normal;color: #FFFFFF; text-shadow: 0 0 1px #FF6600, 0 0 1px #FF6600, 0 0 1px #FF6600;text-align:center}
.ui-loading .sk-circle {width: 100%;height: 100%;position: absolute;left: 0;top: 0;font-size: 7px;font-style: normal;}
.ui-loading .sk-circle:before {content: '';display: block;margin: 0 auto;width: 10%;height: 10%;background-color: #FF6600;border-radius: 100%;animation: ui-loading-delay 1.2s infinite ease-in-out both;}
.ui-loading .sk-circle-2 {transform: rotate(30deg);}
.ui-loading .sk-circle-3 {transform: rotate(60deg);}
.ui-loading .sk-circle-4 {transform: rotate(90deg);}
.ui-loading .sk-circle-5 {transform: rotate(120deg);}
.ui-loading .sk-circle-6 {transform: rotate(150deg);}
.ui-loading .sk-circle-7 {transform: rotate(180deg);}
.ui-loading .sk-circle-8 {transform: rotate(210deg);}
.ui-loading .sk-circle-9 {transform: rotate(240deg);}
.ui-loading .sk-circle-10 {transform: rotate(270deg);}
.ui-loading .sk-circle-11 {transform: rotate(300deg);}
.ui-loading .sk-circle-12 {transform: rotate(330deg);}
.ui-loading .sk-circle-2:before {animation-delay: -1.1s;}
.ui-loading .sk-circle-3:before {animation-delay: -1s;}
.ui-loading .sk-circle-4:before {animation-delay: -0.9s;}
.ui-loading .sk-circle-5:before {animation-delay: -0.8s;}
.ui-loading .sk-circle-6:before {animation-delay: -0.7s;}
.ui-loading .sk-circle-7:before {animation-delay: -0.6s;}
.ui-loading .sk-circle-8:before {animation-delay: -0.5s;}
.ui-loading .sk-circle-9:before {animation-delay: -0.4s;}
.ui-loading .sk-circle-10:before {animation-delay: -0.3s;}
.ui-loading .sk-circle-11:before {animation-delay: -0.2s;}
.ui-loading .sk-circle-12:before {animation-delay: -0.1s;}

@keyframes ui-loading-delay {
  0%, 39%, 100% {opacity: 0;}
  40% {opacity: 1;}
}

</style>

<script>
export default {
  name: 'stloading',
  components: {
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
  },
  created () {
  }
}
</script>
